import type { ReportType } from './types.js';

export type UrlStateSnapshot = {
  slugs: string[];
  hours: number | null;
  report: ReportType | null;
};

export class UrlState {
  read(): UrlStateSnapshot {
    const p = new URLSearchParams(location.search);
    const clientsParam = p.get('clients');
    const slugs = clientsParam ? clientsParam.split(',').filter(Boolean) : [];
    const hoursParam = p.get('hours');
    const parsed = hoursParam ? parseInt(hoursParam, 10) : NaN;
    const hours = Number.isFinite(parsed) && parsed > 0 && parsed <= 720 ? parsed : null;
    const reportParam = p.get('report');
    const normalizedReportParam =
      reportParam === 'campaigns' ? 'campaign-journey' : reportParam;
    const report =
      normalizedReportParam === 'segments' ||
      normalizedReportParam === 'campaign-journey' ||
      normalizedReportParam === 'campaign-delivery'
        ? normalizedReportParam
        : null;
    return { slugs, hours, report };
  }

  write(snapshot: { slugs: Iterable<string>; hours: number; report: ReportType | null }): void {
    const p = new URLSearchParams();
    const slugs = [...snapshot.slugs];
    if (slugs.length) p.set('clients', slugs.join(','));
    if (snapshot.report) p.set('report', snapshot.report);
    if (snapshot.hours && snapshot.hours !== 4) p.set('hours', String(snapshot.hours));
    const qs = p.toString();
    const url = qs ? `?${qs}` : location.pathname;
    history.replaceState(null, '', url);
  }
}
